export default __webpack_public_path__ + "static/media/photo1.89c15c59.jpg";